<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      size="small"
      resizable
      border
      :editConfig="{
        trigger: 'manual',
        mode: 'row',
        showStatus: true,
      }"
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">
              {{ $l('INDEX.booking_backfill_cabinet_info') || '回填柜信息' }}
            </span>
          </div>
        </slot>
      </template>
      <template v-slot:containerAmount="{ row }">
        <span>{{ row.containerPriceAmount }}{{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:containerSalePrice="{ row }">
        <span
          >{{ row.containerSalePriceAmout }}{{ row.v_salesCurrencyUnit }}</span
        >
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    height: { type: Number, default: 300 },
    disabled: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
  },
  data() {
    return {
      data: [],
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },

      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        {
          title: this.$l('INDEX.form_label_containerContractNo') || '外运子单号',
          field: 'containerContractNo',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_containerName') || '箱型',
          field: 'containerName',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_editContainerNo') || '编辑柜号',
          field: 'editContainerNo',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_containerNo') || '集装箱号',
          field: 'containerNo',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_sealNo') || '箱封号',
          field: 'sealNo',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.form_label_containerBoxVolume') ||
            '入柜总体积（立方米）',
          field: 'containerBoxVolume',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.form_label_containerBookingVolume') ||
            '入柜订舱总体积（立方米）',
          field: 'containerBookingVolume',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_containerBoxQty') || '入柜总箱数',
          field: 'containerBoxQty',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_totalNetWeight') || '总净重(kg)',
          field: 'containerNetWeight',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_totalGrossWeight') || '总毛重（kg）',
          field: 'containerGrossWeight',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_totalGoodsQty') || '入柜产品总数量',
          field: 'containerGoodsQty',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_totalPriceAmount') || '工厂金额',
          field: 'containerAmount',
          width: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          slots: {
            default: 'containerAmount',
          },
        },
        {
          title:
            this.$l('INDEX.form_label_containerSalePrice') || '入柜销售总价',
          field: 'containerSalePrice',
          width: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          slots: {
            default: 'containerSalePrice',
          },
        },
      ],
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    headerCellStyle() {
      return {
        backgroundColor: '#bd94c1',
        color: '#ffffff',
      }
    },
    loadData() {
      if (!this.shipmentBookingCode) return
      this.loading = true
      this.$api
        .shipmentBookingContainerListApi({
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: this.shipmentBookingCode,
        })
        .then((res) => {
          this.loading = false
          this.data = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
